import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import { VueAxios } from './axios'
import { isObject } from './util'
import { getToken } from '@/utils/auth'
const  BASE_API = 'http://124.220.205.119/api/'
//const  BASE_API = 'http://124.220.205.119:8080'
// 创建 axios 实例
const service = axios.create({
  // 服务端api地址
  // baseURL: process.env.NODE_ENV === 'production' ? publicConfig.BASE_API : process.env.VUE_APP_API_BASE_URL,
  //baseURL: '/api',
  baseURL: BASE_API,
  timeout: 25 * 1000 // 请求超时时间，25秒, 如果上传大文件需要更长
})

// 接口请求拦截
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = getToken()
    }else{
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 接口响应拦截
service.interceptors.response.use((response) => {
  const result = response.data
  if (!isObject(result)) {
    const error = { message: '服务端api返回的数据格式不正确' }
    return Promise.reject(error)
  }
  // result.status [ 200正常 500有错误 401未登录 403没有权限访问 ]
  // api报错信息
  if (result.code !== '2000') {
    Message.error(result.msg, 1.8)
    return Promise.reject(result)
  }
  // 鉴权失败: 未登录
  if (result.code === 401) {
    store.dispatch('Logout').then(() => {
      Message.error({
        message: '错误',
        description: result.msg,
        duration: 3
      })
      setTimeout(() => {
        window.location.reload()
      }, 1200)
    })
    return Promise.reject(result)
  }
  return result
}, (error) => {
  // 网络请求出错
  const errMsg = ((error.response || {}).data || {}).message || '请求出现错误，请稍后再试'
  Message.error({
    message: '网络请求出错',
    description: errMsg,
    duration: 3
  })
  return Promise.reject(error)
})

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
